/**
 * 导出接口.
 *
 * @author yusangeng@outlook.com
 */
import konph from "./konph";
export { konph };
export default konph;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7R0FJRztBQUVILE9BQU8sS0FBSyxNQUFNLFNBQVMsQ0FBQztBQUc1QixPQUFPLEVBQWUsS0FBSyxFQUFFLENBQUM7QUFDOUIsZUFBZSxLQUFLLENBQUMifQ==